export const APPS = [
  { id: "futures", name: "Rotarsi Al Sat Botu", desc: "RSI(7) + Korumalı Bot · demo borsası" },
  { id: "momo", name: "Rotarsi Al Sat Botu V2", desc: "RSI 65→LONG (çıkış 75 / 50) · RSI 35→SHORT (çıkış 20 / 50) · 10 USDT · demo borsası" },
  { id: "emarsi", name: "Rotarsi EMA-RSI Botu", desc: "EMA 9/21 + RSI(14) · LONG/SHORT · Testnet botları + Backtest" },
];
const KEY = "rotarsi_app";

export const getAppMode = () => {
  const q = new URLSearchParams(window.location.search).get("app");
  if (APPS.some((a) => a.id === q)) return q;
  const v = localStorage.getItem(KEY);
  return APPS.some((a) => a.id === v) ? v : "futures";
};

export const setAppMode = (id) => {
  localStorage.setItem(KEY, id);
  const u = new URL(window.location.href);
  u.searchParams.delete("tab");
  u.searchParams.set("app", id);
  window.location.assign(u.toString());
};
